<template>
  <img v-if="url" :src="url" @error="falhou" />
  <img v-else-if="fallback" :src="fallback" />
  <span v-else>{{ initials }}</span>
</template>

<script>
import { obterArquivoAutenticado } from '../utils/authenticatedFiles'

export default {
  name: 'AuthenticatedImage',
  props: {
    path: { type: String, default: '' },
    endpoint: { type: String, required: true },
    fallback: { type: String, default: '' },
    initials: { type: String, default: '' }
  },
  data: () => ({ url: '', versao: 0 }),
  watch: {
    path: { immediate: true, handler: 'carregar' },
    endpoint: 'carregar'
  },
  beforeUnmount () {
    this.versao++
    this.falhou()
  },
  methods: {
    falhou () {
      if (this.url) URL.revokeObjectURL(this.url)
      this.url = ''
    },
    async carregar () {
      const versao = ++this.versao
      this.falhou()
      if (!this.path) return
      try {
        const arquivo = await obterArquivoAutenticado(this.endpoint, this.path, { showError: false, showLoading: false })
        if (versao === this.versao) this.url = URL.createObjectURL(arquivo)
      } catch (error) {
        // Foto indisponível: preserva o avatar padrão sem bloquear a tela.
      }
    }
  }
}
</script>
